module.exports = __webpack_public_path__ + "static/media/images.15e74f6a.png";